<template>

    <div class="container">
        <div class="row">
            <div :class="step1" class="col-3">Schritt 1</div>
            <div :class="step2" class="col-3">Schritt 2</div>
            <div :class="step3" class="col-3">Schritt 3</div>
            <div :class="step4" class="col-3">Fertig!</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "step-progress",

        props: {
            donesteps: {
                type: Number|String
            }
        },

        computed: {
            step1 () {
                return (this.donesteps >= 1) ? 'bg-success' : ''
            },

            step2 () {
                return (this.donesteps >= 2) ? 'bg-success' : ''
            },

            step3 () {
                return (this.donesteps >= 3) ? 'bg-success' : ''
            },

            step4 () {
                return (this.donesteps === 4) ? 'bg-success' : ''
            }
        }
    }
</script>

<style scoped>
    .col-3 {
        padding: 10px;
        border: 1px solid #ccc;
        text-align: center;
    }

    .col-3:first-child {
        border-radius: 5px 0 0 5px;
    }

    .col-3:last-child {
        border-radius: 0 5px 5px 0;
    }
</style>